/**
 * Copyright (c) 2020-2025, WSO2 Inc. (http://www.wso2.org) All Rights Reserved.
 *
 * WSO2 Inc. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import {HttpClient, HttpError, HttpRequestConfig} from '@asgardeo/javascript';
import {SPACustomGrantConfig} from './request-custom-grant';

export {HttpClient} from '@asgardeo/javascript';
export type {HttpError, HttpRequestConfig, HttpResponse} from '@asgardeo/javascript';

export interface HttpRequestInterface {
  httpClient: HttpClient;
  requestConfig: HttpRequestConfig;
  isHttpHandlerEnabled?: boolean;
  httpErrorCallback?: (error: HttpError) => void | Promise<void>;
  httpFinishCallback?: () => void;
  enableRetrievingSignOutURLFromSession?: (config: SPACustomGrantConfig) => void;
}
